export const LogoMark = ({ size = 44 }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" fill="none" aria-hidden="true" data-testid="logo-mark">
    <defs>
      <linearGradient id="goldGrad" x1="0" y1="0" x2="64" y2="64">
        <stop offset="0%" stopColor="#F3E5AB" />
        <stop offset="55%" stopColor="#D4AF37" />
        <stop offset="100%" stopColor="#A88B32" />
      </linearGradient>
    </defs>
    <circle cx="32" cy="32" r="30" stroke="url(#goldGrad)" strokeWidth="1" opacity="0.55" />
    <path
      d="M18 44 V22 L26 36 L34 22 V44"
      stroke="url(#goldGrad)"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M38 44 L44 22 L50 44 M40.6 36 H47.4"
      stroke="url(#goldGrad)"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M14 50 C 20 47, 26 53, 32 50 C 38 47, 44 53, 50 50"
      stroke="url(#goldGrad)"
      strokeWidth="1.4"
      strokeLinecap="round"
      fill="none"
      opacity="0.85"
    />
  </svg>
);

export const Logo = ({ compact = false }) => (
  <div className="flex items-center gap-3" data-testid="logo">
    <LogoMark size={compact ? 36 : 44} />
    <div className="leading-none">
      <span className="font-display block text-lg sm:text-xl tracking-[0.28em] text-[#F7F5F0] font-medium">
        MALTA ADRIA
      </span>
      <span className="font-label block text-[9px] tracking-[0.42em] text-[#D4AF37] mt-1.5 uppercase">
        Yacht Charter
      </span>
    </div>
  </div>
);
